@if (hierarchy() != null) {
  <div class="hierarchy-container">
    @for (prevLevel of previousLevels; track prevLevel.depth) {
      <div class="hierarchy-level">
        @for (node of prevLevel.nodes; track node.docId) {
          <document-doc-hierarchy-item [item]="node"></document-doc-hierarchy-item>
        }
      </div>
      <i class="digi-out-back"></i>
    }

    <div class="hierarchy-level">
      <document-doc-hierarchy-item
        [item]="hierarchy()"
        [isCurrentDoc]="true"
      ></document-doc-hierarchy-item>
    </div>

    @for (nextLevel of nextLevels; track nextLevel.depth) {
      <i class="digi-out-next"></i>
      <div class="hierarchy-level">
        @for (node of nextLevel.nodes; track node.docId) {
          <document-doc-hierarchy-item [item]="node"></document-doc-hierarchy-item>
        }
      </div>
    }
  </div>
}
